export enum Permissions {
  CanViewEIRecords = 1,
  CanViewReferralRecords = 4,
  CanViewEvaluationRecords = 12,
  CanViewPlacementRecords = 13,
  CanViewIEPRecords = 14,
  CanViewCBSTRecords = 15,
  CanSendPWN = 32,
  CanEditPWN = 34,
  CanViewPWN = 33,
  CanAddReferralRecords = 5,
  CanEditReferralRecords = 6,
  CanSendReevalPWN = 29,
  CanViewReevalPWN = 30,
  CanEditReevalPWN = 31,
  CanApproveRejectReferral = 7,
  CanAddEIRecords = 2,
  CanCompleteReferralRecords = 8,

  // Student Profile
  CanViewStudentProfile = 9,
  CanEditStudentProfile = 10,
  CanCreateStudent = 260,

  //Evalution
  CanEditEvaluationsRecords = 16,
  CanAddEvaluationsRecords = 17,
  CanCompleteEvaluationsRecords = 18,

  //Placements
  CanAddPlacementsRecords = 19,
  CanEditPlacementsRecords = 20,
  CanCompletePlacementsRecords = 21,

  //IEP
  CanAddIEPRecords = 22,
  CanEditIEPRecords = 23,
  CanCompleteIEPRecords = 24,

  //Schedule SHM
  CanScheduleSHM = 35,
  CanReScheduleSHM = 36,

  //CBST
  CanAddCBSTRecords = 25,
  CanEditCBSTRecords = 26,
  CanCompleteCBSTRecords = 27,
  //Schedule Gen
  CanScheduleGEN = 37,

  //Schedule IEP
  CanScheduleIEPMeeting = 66,
  CanRescheduleIEPMeeting = 67,

  //Declassification
  CanCreateDeclassification = 71,
  CanEditDeclassification = 72,

  // Ineligibility
  CanCreateIneligibilityDocument = 75,

  //Assurance Checklist
  CanEditAssuranceChecklist = 83,

  //lre
  CanEditLREForm = 80,
  CanCreateLREForm = 82,

  //Waiver
  CanCreateWaiverofIEPMeeting = 73,

  CanCreatePreSchoolSummary = 44,
  CanEditCPreSchoolSummary = 45,
  CanInitiateAssessmentPlanning = 42,

  CanCreate12MonthSchoolYearConsentForm = 68,
  CanEdit12MonthSchoolYearConsentForm = 69,

  CanCreateNoticeofTermination = 96,
  CanEditNoticeofTermination = 97,

  CanCreateConsentforInitialProvisionofServices = 87,
  CanEditConsentforInitialProvisionofServices = 94,

  CanCreatePriorNoticeforPlacementWithdrawal = 89,
  CanEditPriorNoticeforPlacementWithdrawal = 91,
  CanCreateParentWithdrawalofConsent = 92,

  CanEditPTTeacherChecklist = 59,
  CanEditPTParentChecklist = 60,
  CanEditTeacherOTChecklist = 61,
  CanEditParentOTChecklist = 62,

  CanViewReports = 278,
  CanAccessOperationalReports = 259,

  //Befit Review
  CanCreateEdBenefitReview = 111,
  CanViewEdBenefitReview = 112,

  CanRequesttoSharePersonallyIdentifiableInformation = 38,
  CanViewPersonallyIdentifiableInformation = 116,

  CanCaseClose = 104,

  CanSendParentRequestforAdditionalAssessments = 39,
  CanEditParentRequestforAdditionalAssessments = 40,
  CanViewParentRequestforAdditionalAssessments = 100,
  CanReviewParentRequestforAdditionalAssessments = 265,
  CanGenerateProgressReport = 270,
  CanLogOutreach = 271,
  CanDeleteDocument = 274,

  CanAssignToAgency = 275,
  CanViewGlobalSearch = 279,

  CanCaptureFirstAttend = 114,
  CanViewAdvancedFilters = 467,
}
